/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {HVSRecords} from '@ion/core/src/types/entities';

// Defines ids for persistent iframes used in reports.
export enum iframeIds {
  scheduler = 'scheduler-iframe',
  dashboard = 'dashboard-iframe'
};

// types used in AssetHistorySettings
interface AssetHistorySettings {
  label: string,
  name: string,
  tooltip?: string,
  checked: boolean,
  onChange?: Function
};

export interface AssetHistorySettingsGroup extends AssetHistorySettings{
  subSettings?: AssetHistorySettings[];
};

// defines the AHR setting enum...
export enum Settings {
  SummaryCard = 'summaryCard',
  TotalAssetsCard = 'totalAssetsCard',
  TotalDistanceCard = 'totalDistanceCard',
  TotalIdleCard = 'totalIdleCard',
  TotalDrivenTimeCard = 'totalDrivenTimeCard',
  TotalHarshCard = 'totalHarshCard',
  TripCard = 'tripCard',
  EventsCard = 'eventsCard',
  DistanceTravelled = 'distanceTravelled',
  IdlingTime = 'idlingTime',
  DrivingTime = 'drivingTime',
  HarshEvents = 'harshEvents',
};

// defines the AHR settings for the label...
export enum AssetHistorySettingOptionLabels {
  showSummary = 'tracking:assetHistorySettingsOptions.summary.label',
  distanceTravelled = 'tracking:assetHistorySettingsOptions.summary.subSettings.distanceTravelled.label',
  idlingTime = 'tracking:assetHistorySettingsOptions.summary.subSettings.idlingTime.label',
  drivingTime = 'tracking:assetHistorySettingsOptions.summary.subSettings.drivingTime.label',
  harshEvents = 'tracking:assetHistorySettingsOptions.summary.subSettings.harshEvents.label',
  showTotalAssets = 'tracking:assetHistorySettingsOptions.summary.subSettings.showTotalAssets.label',
  showTrip = 'tracking:assetHistorySettingsOptions.trips.label',
  showEvents = 'tracking:assetHistorySettingsOptions.trips.subSettings.showEvents.label'
};

// defines the AHR settings for the tooltip label...
export enum AssetHistorySettingOptionTooltip {
  showSummary = 'tracking:assetHistorySettingsOptions.summary.tooltip',
  showTrip = 'tracking:assetHistorySettingsOptions.trips.tooltip',
  showEvents = 'tracking:assetHistorySettingsOptions.trips.subSettings.showEvents.tooltip'
};

export type TrackingHistoryMapInterface = Record<number, HVSRecords>
